import { request } from "@/utils/request";
import { BASE_URL } from "@/constants/config";

export const LABELS_ENDPOINTS = {
  main: `${BASE_URL}api/labels/`,
  byId: (id) => `${BASE_URL}api/labels/${id}/`,
  byName: (name) => `${BASE_URL}api/labels/name/${name}/`,
};

class Labels {
  async isUnique(name) {
    const { data } = await request({
      url: LABELS_ENDPOINTS.byName(name),
      method: "GET",
    });
    return data;
  }
  async getLabels() {
    const { data } = await request({
      url: LABELS_ENDPOINTS.main,
      method: "GET",
      query: {per_page: 9999}
    });
    return data;
  }
  async getLabel(id) {
    const { data } = await request({
      url: LABELS_ENDPOINTS.byId(id),
      method: "GET",
    });
    return data;
  }
  async deleteLabel(id) {
    await request({
      url: LABELS_ENDPOINTS.byId(id),
      method: "DELETE",
    });
  }
  async editOrCreateLabel(id = null, payload = {}) {
    const isEdit = id && id !== 'create';
    const { res } = await request({
      url: isEdit ? LABELS_ENDPOINTS.byId(id) : LABELS_ENDPOINTS.main,
      method: isEdit ? "PUT" : "POST",
      body: payload,
    });
    return res
  }
}

export const LabelsService = new Labels();
